export const ICONS = {
    PORTFOLIO: 'ii5-assets'
}
